import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Invoice from 'screens/Invoices/Invoice';
import InvoiceRouteAdmin, {
  InvoiceFlow
} from 'screens/Invoices/redesign/InvoiceRouteAdmin';
import useInvoiceFlags from 'screens/Invoices/redesign/hooks/useInvoiceFlags';

interface DuplicateLocationState {
  invoiceId?: string;
}

/**
 * Route guard for `/app/invoices/:id/duplicate`.
 *
 * When the redesign flag is active the new multi-step duplicate flow is
 * rendered via InvoiceRouteAdmin.  The invoice id is resolved from the URL
 * param `:id` first, falling back to `location.state.invoiceId` for
 * action-menu entry points that navigate with state instead of a param.
 * When the flag is off the legacy Invoice component handles the request.
 */
const InvoiceDuplicateGuard: React.FC = () => {
  const { id: paramId } = useParams<{ id: string }>();
  const { state } = useLocation<DuplicateLocationState | undefined>();
  const { feInvoicesActive } = useInvoiceFlags();

  const invoiceId = paramId || state?.invoiceId;

  if (feInvoicesActive) {
    return (
      <InvoiceRouteAdmin flow={InvoiceFlow.DUPLICATE} invoiceId={invoiceId} />
    );
  }

  return <Invoice />;
};

export default InvoiceDuplicateGuard;
